import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pune',
  templateUrl: './pune.component.html',
  styleUrls: ['./pune.component.scss']
})
export class PuneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
 
    
  numb: any=[
    {
      n:'1',
      xy:'26px 0 0 50px'
    },
    {
      n:'2',
      xy:'12px 0 0 120px'
    },
    {
      n:'3',
      xy:'12px 0 0 204px'
    },
    {
      n:'4',
      xy:'28px 0 0 280px'
    },
    {
      n:'5',
      xy:'28px 0 0 364px'
    },
    {
      n:'6',
      xy:'16px 0 0 432px'
    },
    {
      n:'7',
      xy:'16px 0 0 516px'
    },
    {
      n:'8',
      xy:'108px 0 0 50px'
    },
    {
      n:'9',
      xy:'94px 0 0 120px'
    },
    {
      n:'10',
      xy:'94px 0 0 204px'
    },
    {
      n:'11',
      xy:'110px 0 0 280px'
    },
    {
      n:'12',
      xy:'110px 0 0 364px'
    },
    {
      n:'13',
      xy:'98px 0 0 432px'
    },
    {
      n:'14',
      xy:'98px 0 0 516px'
    },
    {
      n:'15',
      xy:'140px 0 0 50px'
    },
    {
      n:'16',
      xy:'126px 0 0 120px'
    },
    {
      n:'17',
      xy:'126px 0 0 204px'
    },
    {
      n:'18',
      xy:'142px 0 0 280px'
    },
    {
      n:'19',
      xy:'142px 0 0 364px'
    },
    {
      n:'20',
      xy:'130px 0 0 432px'
    },
    {
      n:'21',
      xy:'130px 0 0 516px'
    },
    {
      n:'22',
      xy:'196px 0 0 14px'
    },
    {
      n:'23',
      xy:'250px 0 0 14px'
    },
    {
      n:'24',
      xy:'278px 0 0 18px'
    },
    {
      n:'25',
      xy:'329px 0 0 335px'
    },
    {
      n:'26',
      xy:'352px 0 0 297px'
    },
    {
      n:'27',
      xy:'374px 0 0 335px'
    },
    {
      n:'28',
      xy:'424px 0 0 300px'
    },
    {
      n:'29',
      xy:'450px 0 0 42px'
    },
    {
      n:'30',
      xy:'450px 0 0 100px'
    },
    {
      n:'31',
      xy:'482px 0 0 42px'
    },
    {
      n:'32',
      xy:'482px 0 0 100px'
    },
    {
      n:'33',
      xy:'605px 0 0 48px'
    },
    {
      n:'34',
      xy:'605px 0 0 134px'
    },
    {
      n:'35',
      xy:'636px 0 0 134px'
    },
    {
      n:'36',
      xy:'636px 0 0 48px'
    },
    {
      n:'37',
      xy:'636px 0 0 190px'
    },
    {
      n:'38',
      xy:'605px 0 0 190px'
    },
    {
      n:'39',
      xy:'543px 0 0 296px'
    },
    {
      n:'40',
      xy:'570px 0 0 266px'
    },
    {
      n:'41',
      xy:'570px 0 0 326px'
    },
    {
      n:'42',
      xy:'594px 0 0 326px'
    },
    {
      n:'43',
      xy:'594px 0 0 266px'
    },
    {
      n:'44',
      xy:'618px 0 0 266px'
    },
    {
      n:'45',
      xy:'618px 0 0 326px'
    },
    {
      n:'46',
      xy:'642px 0 0 266px'
    },
    {
      n:'47',
      xy:'642px 0 0 326px'
    },
    {
      n:'48',
      xy:'669px 0 0 296px'
    }
    
  ];

}
